import { monthYear } from 'Consts/DateFormats';
import { Table } from '@facet-wealth/design';
import { buildFacetDesignOverride } from 'Packages/FacetRest/FacetDesignOverride';
import { CheckboxInputLarge } from 'Packages/FacetDesign/Components/CheckboxInput';

export default buildFacetDesignOverride()
  .override({ readonly: true }, {
    _component: () => Table.BodyCellText,
  }, {
    ordinal: 200,
  })
  .override({ name: 'createOnActivation' }, {
    _component: () => CheckboxInputLarge,
    _customProps: {
      label: '',
      helperText: '',
    },
  }, {
    ordinal: 300,
  })
  .typeOverride('date', {
    _formatString: monthYear,
  });
